import { render, staticRenderFns } from "./damagedPartCamera.pug?vue&type=template&id=0d1ada20&lang=pug&external"
import script from "./damagedPartCamera.js?vue&type=script&lang=js&external"
export * from "./damagedPartCamera.js?vue&type=script&lang=js&external"
import style0 from "./damagedPartCamera.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/luis.rodriguez/Documents/Multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d1ada20')) {
      api.createRecord('0d1ada20', component.options)
    } else {
      api.reload('0d1ada20', component.options)
    }
    module.hot.accept("./damagedPartCamera.pug?vue&type=template&id=0d1ada20&lang=pug&external", function () {
      api.rerender('0d1ada20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/multidamageList/components/damagedPartCamera/index.vue"
export default component.exports